import { createFileRoute } from '@tanstack/react-router'
import { Board } from './-components/shared/board'
import { BoardPending } from './-components/shared/board-pending'
import { useTeam } from '@/hooks/use-team'
import { prefetchReport } from '@/hooks/use-report'
import { TeamsEmptyState } from './-components/teams/teams-empty-state'
import { ReportError } from './-components/shared/report-error'
import { EmptyState } from './-components/shared/empty-state'

export const Route = createFileRoute('/_app/teams/$teamId/board')({
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps, params }) => {
    prefetchReport(context.queryClient, deps, params)
  },
  component: RouteComponent,
  pendingComponent: BoardPending,
})

function RouteComponent() {
  const { teamId } = Route.useParams()
  const { team } = useTeam()

  // `visibleMembers` is already restricted to the selected self-assessments for `ownsManual` (server-side).
  const boardProfiles = (team?.visibleMembers ?? []).map((profile) => ({ ...profile, id: profile.id.toString() }))

  if (team?.error === 'teams-see-owns') {
    return <ReportError error="noPermissionsSeeOwns" surface="board" />
  }

  if (team?.emptyStateCode) {
    return <EmptyState code={team.emptyStateCode} surface="board" />
  }
  // Residual `profile-blocked` with members present (not a count-empty state).
  if (team?.error) {
    return <TeamsEmptyState type="no-members" teamId={teamId} />
  }

  return <Board name={team?.name ?? ''} profiles={boardProfiles} standardIndicators={team?.indicators} />
}
